<template>
	<div class="co-totals-container">
		<h2 v-bind="ADAattr('hidden')">Order Summary</h2>
		<h2 v-bind="ADAattr('sr-only', false)">Order Summary:</h2>

		<div class="order-summary-container">
			<div class="os-charges">
				<div class="osc-line" v-for="(charge, c_index) in charges" :key="c_index">
					<div class="oscl-name" v-bind="ADAattr('hidden')">{{ getSummaryCaption(charge.name) }}</div>
					<div v-if="isIncomplete && ['shipping','tax'].indexOf(charge.name) >= 0" class="oscl-value" v-bind="ADAattr('hidden')">--</div>
					<div v-else class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(charge.value)}` }}</div>
					<div v-bind="ADAattr('sr-only', false)">{{ `${getSummaryCaption(charge.name)}: $${formatPrice(charge.value)}` }},</div>
				</div>
			</div>

			<div class="os-vouchers" v-if="payments.length && !isIncomplete">
				<template v-for="(payment, p_index) in payments">
					<div class="osc-line" v-if="payment.name === 'fin_aid_payment' && payment.value > 0">
						<div class="oscl-name" v-bind="ADAattr('hidden')">{{ getFinAidAppliedAmountLabel($globs) }}</div>
						<div class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(payment.value)}` }}</div>
						<div v-bind="ADAattr('sr-only', false)">{{ `${getFinAidAppliedAmountLabel($globs)}: $${formatPrice(payment.value)}` }},</div>
					</div>
					<div class="osc-line" v-if="payment.name === 'cc_payment' && payment.value > 0">
						<div class="oscl-name" v-bind="ADAattr('hidden')">{{cc_amount_label}}</div>
						<div class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(payment.value)}` }}</div>
						<div v-bind="ADAattr('sr-only', false)">{{cc_amount_label}} payment: ${{ formatPrice(payment.value) }},</div>
					</div>
					<div class="osc-line" v-if="payment.name === 'gc_payment' && payment.value > 0">
						<div class="oscl-name" v-bind="ADAattr('hidden')">{{ getVoucherAppliedAmountLabel($globs) }}</div>
						<div class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(payment.value)}` }}</div>
						<div v-bind="ADAattr('sr-only', false)">{{ getVoucherAppliedAmountLabel($globs) }} payment: ${{ formatPrice(payment.value) }},</div>
					</div>
				</template>
			</div>

			<div class="os-total" v-if="total">
				<div class="osc-line">
					<div class="oscl-name" v-bind="ADAattr('hidden')">{{ getSummaryCaption('total', isIncomplete) }}</div>
					<div v-if="isIncomplete" class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(sub_total)}` }}</div>
					<div v-else class="oscl-value" v-bind="ADAattr('hidden')">{{ `$${formatPrice(total)}` }}</div>
					<div v-bind="ADAattr('sr-only', false)">{{ getSummaryCaption('total') }}: ${{ formatPrice(total) }}</div>
				</div>
			</div>

			<div class="os-incomplete" v-if="isIncomplete">
				<div class="osc-line">
					<small>&#42; Total does not include shipping and taxes</small>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {getSummaryCaption, getFinAidAppliedAmountLabel, getVoucherAppliedAmountLabel, getCCPaymentLabel} from './../includes/SpecialCasesHandles';
	import {formatPrice} from './../includes/Miscellaneous';

	export default {
		name: "OrderSummary",

		props: {
			charges: {
				type: Array,
				default: () => [],
			},
			payments: {
				type: Array,
				default: () => [],
			},
			total: {
				type: Number,
				default: 0,
			},
			onlinePayment: {
				type: String,
				default: ''
			},
			isIncomplete: {
			  type: Boolean,
			  default: false
			}
		},

		data() {
			return {};
		},

		methods: {
			formatPrice,
			getFinAidAppliedAmountLabel,
			getVoucherAppliedAmountLabel,
			getCCPaymentLabel,

			getSummaryCaption(key, is_incomplete) {
				return getSummaryCaption(this.$globs, key, is_incomplete);
			},
		},
		computed: {
			cc_amount_label() {
				return this.onlinePayment ? this.onlinePayment : 'Credit Card';
			},
			sub_total() {
				for (const i in this.charges) {
					if (this.charges[i].name === 'subtotal') {
						return this.charges[i].value;
					}
				}
				return 0;
			}
		}
	};
</script>

<style scoped lang="less">
	.co-totals-container {
		border: 2px solid #DDDDDD;
		margin-left: 20px;
		margin-top: 6px;
		padding: 15px 20px;

		@media screen and (max-width: 600px) {
			margin-left: 4px;
		}

		h2 {
			text-align: left;
			border-bottom: 1px solid #ccc;
			padding: 5px 0 10px;
			color: #000 !important;
			margin: 0;
		}

		.order-summary-container {
			.os-charges, .os-vouchers, .os-total {
				overflow: hidden;
				margin: 10px 0;

				.osc-line {
					padding: 5px 0;

					.oscl-name {
						float: left;
						width: 60%;
					}

					.oscl-value {
						float: left;
						width: 40%;
						text-align: right;
					}
				}
			}

			.os-vouchers {
				border-top: 1px solid #ccc;
				font-weight: bold;
			}

			.os-total {
				border-top: 1px solid #ccc;
				font-weight: bold;

				.oscl-value {
					font-size: 16px;
				}
			}
		}
	}
</style>